var _rect, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMoodBad = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3120",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7714 20.7714C32.2829 21.2599 31.7022 21.5 31 21.5C30.2978 21.5 29.7171 21.2599 29.2286 20.7714C28.7401 20.2829 28.5 19.7022 28.5 19C28.5 18.2978 28.7401 17.7171 29.2286 17.2286C29.7171 16.7401 30.2978 16.5 31 16.5C31.7022 16.5 32.2829 16.7401 32.7714 17.2286C33.2599 17.7171 33.5 18.2978 33.5 19C33.5 19.7022 33.2599 20.2829 32.7714 20.7714ZM18.7714 20.7714C18.2829 21.2599 17.7022 21.5 17 21.5C16.2978 21.5 15.7171 21.2599 15.2286 20.7714C14.7401 20.2829 14.5 19.7022 14.5 19C14.5 18.2978 14.7401 17.7171 15.2286 17.2286C15.7171 16.7401 16.2978 16.5 17 16.5C17.7022 16.5 18.2829 16.7401 18.7714 17.2286C19.2599 17.7171 19.5 18.2978 19.5 19C19.5 19.7022 19.2599 20.2829 18.7714 20.7714ZM24 43.5C21.2984 43.5 18.7661 42.9877 16.3981 41.9659C14.0204 40.9399 11.957 39.5499 10.2036 37.7964C8.45007 36.043 7.06009 33.9796 6.03408 31.6019C5.01226 29.2339 4.5 26.7016 4.5 24C4.5 21.2984 5.01226 18.7661 6.03408 16.3981C7.06009 14.0204 8.45007 11.957 10.2036 10.2036C11.957 8.45007 14.0204 7.06009 16.3981 6.03408C18.7661 5.01226 21.2984 4.5 24 4.5C26.7016 4.5 29.2339 5.01226 31.6019 6.03408C33.9796 7.06009 36.043 8.45007 37.7964 10.2036C39.5499 11.957 40.9399 14.0204 41.9659 16.3981C42.9877 18.7661 43.5 21.2984 43.5 24C43.5 26.7016 42.9877 29.2339 41.9659 31.6019C40.9399 33.9796 39.5499 36.043 37.7964 37.7964C36.043 39.5499 33.9796 40.9399 31.6019 41.9659C29.2339 42.9877 26.7016 43.5 24 43.5ZM24 40.5C28.5965 40.5 32.5078 38.8993 35.7036 35.7036C38.8993 32.5078 40.5 28.5965 40.5 24C40.5 19.4035 38.8993 15.4922 35.7036 12.2964C32.5078 9.10072 28.5965 7.5 24 7.5C19.4035 7.5 15.4922 9.10072 12.2964 12.2964C9.10072 15.4922 7.5 19.4035 7.5 24C7.5 28.5965 9.10072 32.5078 12.2964 35.7036C15.4922 38.8993 19.4035 40.5 24 40.5Z",
    fill: "#F2BD00",
    stroke: "#F2BD00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 28,
    width: 20,
    height: 4,
    rx: 2,
    fill: "#F2BD00"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoodBad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mood_bad.e4d5486e.svg";
export { ForwardRef as ReactComponent };